export interface IPhotoRequest {
  container: string;
  fileName: string;
  photoUrl: string;
}

export interface IPhotoModel extends IPhotoRequest {
  photoId: number;
  processedPhotoBaseUrl: string;
}

export class PhotoModel implements IPhotoModel {
  photoId: number;
  container: string;
  fileName: string;
  photoUrl: string;
  processedPhotoBaseUrl: string;

  constructor(params: Partial<IPhotoModel> = {}) {
    const {
      photoId = 0,
      container = '',
      fileName = '',
      photoUrl = '',
      processedPhotoBaseUrl = '',
    } = params;

    this.photoId = photoId;
    this.container = container;
    this.fileName = fileName;
    this.photoUrl = photoUrl;
    this.processedPhotoBaseUrl = processedPhotoBaseUrl;
  }
}
